import React from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Typography,
} from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { parseDate } from '../../../utils/helpers/dateHelpers/parseDate'
import gamesTabStyles from './gamesTab.styles'
import parseTime from '../../../utils/helpers/dateHelpers/parseTime'
import COLORS from '../../../utils/constants/colors'
import LiteModeBadge from '../../../components/LiteModeBadge/LiteModeBadge'

const useStyles = makeStyles(gamesTabStyles)

const GamesTab = ({ selectedGameday, onNewGameClick, onEditGameClick, onDeleteGameClick }) => {
  const classes = useStyles()

  // Get games from the selected gameday
  const games = selectedGameday?.games || []

  const handleEditGame = (gameId) => {
    if (onEditGameClick) {
      onEditGameClick(gameId)
    }
  }

  const handleDeleteGame = (game) => {
    if (onDeleteGameClick) {
      onDeleteGameClick(game)
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {selectedGameday ? (
          <Button
            variant='contained'
            style={{ backgroundColor: COLORS.orange, color: 'white' }}
            startIcon={<Add />}
            onClick={onNewGameClick}
          >
            New Game
          </Button>
        ) : (
          <Typography variant='body2' color='textSecondary'>
            Please select a gameday to manage games
          </Typography>
        )}
      </div>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Location</TableCell>
              <TableCell align='right'>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {games.length > 0 ? (
              games.map((game) => (
                <TableRow key={game.id}>
                  <TableCell>
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      {game.title || 'N/A'}
                      <LiteModeBadge statsMode={game.statsMode} />
                    </span>
                  </TableCell>
                  <TableCell>{parseDate(game.startDateTime) || 'N/A'}</TableCell>
                  <TableCell>{parseTime(game.startDateTime) || 'N/A'}</TableCell>
                  <TableCell>{game.place || 'N/A'}</TableCell>
                  <TableCell align='right'>
                    <div className={classes.actionButtons}>
                      <IconButton
                        size='small'
                        onClick={() => handleEditGame(game.id)}
                      >
                        <Edit style={{ fill: COLORS.orange }} />
                      </IconButton>
                      <IconButton
                        size='small'
                        onClick={() => handleDeleteGame(game)}
                      >
                        <Delete style={{ fill: COLORS.purple }} />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align='center'>
                  No games found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default GamesTab
